export enum AppointmentType {
    Expedition = 1,
    Reception = 2,
}
